// extracted by mini-css-extract-plugin
export default {"p_content":"_1d67fc6ca8"};